import React, { useState } from 'react';
import { toast } from 'sonner';
import { Eraser, Loader2, Lock } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog';

const API = process.env.REACT_APP_BACKEND_URL;

export const ClearFollowUpsDialog = ({ open, onOpenChange, token, onCleared }) => {
  const [pw, setPw] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const close = (v) => { if (!v) { setPw(''); setErr(''); } onOpenChange(v); };
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr('');
    try {
      const r = await fetch(`${API}/api/nurture/follow-ups/clear-all`, { method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }, body: JSON.stringify({ password: pw }) });
      const d = await r.json();
      if (!r.ok) { setErr(d.detail || 'Could not clear follow-ups'); return; }
      toast.success(`Cleared ${d.follow_ups_cleared} follow-ups across ${d.leads_cleared} leads`);
      close(false); onCleared?.();
    } catch { setErr('Network error — please try again'); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="sm:max-w-md rounded-3xl" data-testid="clear-fu-dialog">
        <DialogHeader>
          <div className="w-11 h-11 rounded-2xl bg-rose-50 ring-1 ring-rose-200 flex items-center justify-center mb-2"><Eraser className="w-5 h-5 text-rose-600" /></div>
          <DialogTitle className="text-xl font-black tracking-tight">Clear all follow-ups</DialogTitle>
          <DialogDescription>Removes every <b>overdue</b>, <b>due today</b> and <b>upcoming</b> follow-up from all leads. Leads themselves are kept. This can't be undone.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div className="relative">
            <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input type="password" autoFocus value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Master password" data-testid="clear-fu-password"
              className="w-full rounded-xl border border-slate-200 pl-9 pr-3 py-2.5 text-sm outline-none focus:border-rose-400 focus:ring-2 focus:ring-rose-100" />
          </div>
          {err && <p className="text-xs font-semibold text-rose-600" data-testid="clear-fu-error">{err}</p>}
          <div className="flex justify-end gap-2 pt-1">
            <button type="button" onClick={() => close(false)} className="rounded-full px-4 py-2 text-[13px] font-bold text-slate-600 hover:bg-slate-100" data-testid="clear-fu-cancel">Cancel</button>
            <button type="submit" disabled={!pw || busy} className="inline-flex items-center gap-1.5 rounded-full px-5 py-2 text-[13px] font-bold text-white bg-rose-600 hover:bg-rose-700 disabled:opacity-50" data-testid="clear-fu-confirm">
              {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Eraser className="w-3.5 h-3.5" />} Clear everything
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
